import { Injector, NgModule } from '@angular/core';

import { epicObs } from '../store';

import { EvaluationService } from './core';
import { setModuleInjector } from './evaluation.metadata';
import { formEpics } from './form';
import { CmpsEvalLandingModule, landingEpics } from './landing';
import { CmpsEvalMainModule, mainEpics } from './main';
import { CmpsEvalSearchModule, searchEpics } from './search';

@NgModule({
    exports: [CmpsEvalLandingModule, CmpsEvalMainModule, CmpsEvalSearchModule],
    imports: [CmpsEvalLandingModule, CmpsEvalMainModule, CmpsEvalSearchModule],
    providers: [EvaluationService],
})
export class CmpsEvaluationModule {
    constructor(private readonly _injector: Injector) {
        setModuleInjector(_injector);
        landingEpics.forEach((e) => epicObs.next(e));
        mainEpics.forEach((e) => epicObs.next(e));
        searchEpics.forEach((e) => epicObs.next(e));
        formEpics.forEach((e) => epicObs.next(e));
    }
}
